import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AlertController, ModalController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { Appointment } from 'src/app/core/models/appointment.model';
import { WorkforceFormEntry } from 'src/app/core/models/workforce-form.model';
import { AppointmentService } from 'src/app/core/services/appointment/appointment.service';
import { WorkforceFormComponent } from '../../workforce-form/workforce-form.component';
import { AppointmentWorkforceForm } from 'src/app/core/models/appointment-workforce-form.model';

@Component({
     selector: 'app-forms-tab',
     templateUrl: './forms-tab.component.html',
     styleUrls: ['./forms-tab.component.scss'],
})

export class FormsTabComponent {

     hiddenSections = [] as number[];
     appointment: Appointment;
     destroyed$: Subject<boolean>;

     constructor(
          private activatedRoute: ActivatedRoute,
          private appointmentService: AppointmentService,
          private modalController: ModalController,
          private alertController: AlertController,
     ) {


     }

     async ionViewDidEnter() {
          this.destroyed$ = new Subject();
          const id = this.activatedRoute.snapshot.parent.parent.params?.id;
          this.appointment = await this.appointmentService.getLocalAppointment(id);
          //console.table(this.appointment);
     }

     ionViewWillLeave() {
          this.destroyed$.next(true);
          this.destroyed$.complete();
     }

     async getWorkforceForms() {

          this.appointment = await this.appointmentService.getLocalAppointment(this.appointment.id);
     }

     async onClickAddWorkforceForm(): Promise<void> {
          await this.showForm(null, 'Add');
     }

     async onClickEditWorkforceForm(workforceForm: WorkforceFormEntry): Promise<void> {
          await this.showForm(workforceForm, 'Edit');
     }

     async showForm(workforceForm: WorkforceFormEntry, mode: string) {
          let apptWorkforceForm = new AppointmentWorkforceForm({
               apptId: this.appointment.id,
               apptStart: this.appointment.apptStart,
               displayValue: this.appointment.displayValue,
          });

          const modal = await this.modalController.create({
               component: WorkforceFormComponent,
               componentProps: {
                    mode,
                    workforceForm,
                    apptWorkforceForm,
                    hidden: ['appointment'],
               },
               cssClass: 'full-screen-modal',
          });

          await modal.present();
          await modal.onDidDismiss();
          await this.getWorkforceForms();
     }

     async deleteForm(workforceForm: WorkforceFormEntry): Promise<void> {
          console.log(this.appointment.id);

          await this.appointmentService.deleteWorkforceForm(this.appointment.id, workforceForm);
          this.appointment = await this.appointmentService.getLocalAppointment(this.appointment.id);
     }

     async onClickDeleteWorkforceForm(workforceForm): Promise<void> {

          const alert = await this.alertController.create({
               header: 'Confirm Delete',
               message: 'Are you sure you would like to delete this form entry?',
               backdropDismiss: false,
               buttons: [
                    {
                         text: 'No',
                         role: 'cancel',
                         cssClass: 'secondary',
                    }, {
                         text: 'Yes',
                         handler: async () => {
                              await this.deleteForm(workforceForm);
                         }
                    }
               ]
          });

          await alert.present();
     }

     onClickToggleSection(sectionIndex: number) {
          const foundIndex = this.hiddenSections.findIndex(index => index === sectionIndex);
          if (foundIndex === -1) {
               this.hiddenSections.push(sectionIndex);
               return;
          }

          this.hiddenSections.splice(foundIndex, 1);
     }

     isVisible(sectionIndex: number) {
          return (this.hiddenSections.findIndex(index => index === sectionIndex) > -1);
     }

     hasSignature(workforceForm) {
          return workforceForm?.entries?.find(e => e.fieldTypeDescription === 'Signature')?.value?.length > 0;
     }
}
